export default [
  {
    name: '夏促活动',
    path: '/gk/activity/vip/purchase/25summer',
    component: () => import('@/views/activity/2025/vip-purchase/VipPurchaseV2.vue'),
  },
  {
    name:"Twitter话题活动",
    path: '/gk/activity/2025/top-news',
    component: () => import('@/views/activity/2025/top-news/TopNews.vue')
  },
  {
    name: '学习报告',
    path: '/gk/activity/2025/learning-report',
    component: () => import('@/views/activity/2025/learning-report/LearningReport.vue')
  }
];
